import state from "./state";
import storage from "../utils/storage";

export default {
  loginMsg() {
    if (state.loginMsg) {
      return state.loginMsg
    }
    if (storage.getData('loginMsg')) {
      return storage.getData('loginMsg')
    }
  },
  config() {
    if (state.config) {
      return state.config
    }
    if (storage.getData('config')) {
      return storage.getData('config')
    }
  },
  deviceConfig() {
    if (state.deviceConfig) {
      return state.deviceConfig
    }
    if (storage.getData('deviceConfig')) {
      return storage.getData('deviceConfig')
    }
  },
  carNo() {
    if (state.carNo) {
      return state.carNo
    }
    if (storage.getData('carNo')) {
      return storage.getData('carNo')
    }
  },
  currentBill() {
    if (state.currentBill) {
      return state.currentBill
    }
    if (storage.getData('currentBill')) {
      return storage.getData('currentBill')
    }
  },
  idCardInfo() {
    if (state.idCardInfo) {
      return state.idCardInfo
    }
    if (storage.getData('idCardInfo')) {
      return storage.getData('idCardInfo')
    }
  },
  icCard() {
    if (state.icCard) {
      return state.icCard
    }
    if (storage.getData('icCard')) {
      return storage.getData('icCard')
    } else {
      return ''
    }
  },
  printMsg() {
    if (state.printMsg) {
      return state.printMsg
    }
    if (storage.getData('printMsg')) {
      return storage.getData('printMsg')
    }
  },
  carMainMsg() {
    if (state.carMainMsg) {
      return state.carMainMsg
    }
    if (storage.getData('carMainMsg')) {
      return storage.getData('carMainMsg')
    }
  },
  costMsg() {
    if (state.costMsg) {
      return state.costMsg
    }
    if (storage.getData('costMsg')) {
      return storage.getData('costMsg')
    }
  },
  costChoose() {
    if (state.costChoose) {
      return state.costChoose
    }
    if (storage.getData('costChoose')) {
      return storage.getData('costChoose')
    }
  },
  payList() {
    if (state.payList) {
      return state.payList
    }
    if (storage.getData('payList')) {
      return storage.getData('payList')
    }
  },
  faceImg() {
    if (state.faceImg) {
      return state.faceImg
    }
    if (storage.getData('faceImg')) {
      return storage.getData('faceImg')
    }
  },
  SSeInfo() {
    if (state.SSeInfo) {
      return state.SSeInfo
    }
    if (storage.getData('SSeInfo')) {
      return storage.getData('SSeInfo')
    }
  },
  warehouseFloor() {
    return state.warehouseFloor || '1f'
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js